/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiDashboardGetDashboardGet } from '../fn/dashboard/api-dashboard-get-dashboard-get';
import { ApiDashboardGetDashboardGet$Params } from '../fn/dashboard/api-dashboard-get-dashboard-get';
import { apiDashboardGetDashboardGet$Plain } from '../fn/dashboard/api-dashboard-get-dashboard-get-plain';
import { ApiDashboardGetDashboardGet$Plain$Params } from '../fn/dashboard/api-dashboard-get-dashboard-get-plain';
import { apiDashboardGetDashboardV2Post } from '../fn/dashboard/api-dashboard-get-dashboard-v-2-post';
import { ApiDashboardGetDashboardV2Post$Params } from '../fn/dashboard/api-dashboard-get-dashboard-v-2-post';
import { apiDashboardGetDashboardV2Post$Plain } from '../fn/dashboard/api-dashboard-get-dashboard-v-2-post-plain';
import { ApiDashboardGetDashboardV2Post$Plain$Params } from '../fn/dashboard/api-dashboard-get-dashboard-v-2-post-plain';
import { GetDashboardQueryResult } from '../models/get-dashboard-query-result';
import { GetDashboardV2QueryResult } from '../models/get-dashboard-v-2-query-result';

@Injectable({ providedIn: 'root' })
export class DashboardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiDashboardGetDashboardGet()` */
  static readonly ApiDashboardGetDashboardGetPath = '/api/Dashboard/GetDashboard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashboardGetDashboardGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardGetDashboardGet$Plain$Response(params?: ApiDashboardGetDashboardGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDashboardQueryResult>> {
    return apiDashboardGetDashboardGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDashboardGetDashboardGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardGetDashboardGet$Plain(params?: ApiDashboardGetDashboardGet$Plain$Params, context?: HttpContext): Observable<GetDashboardQueryResult> {
    return this.apiDashboardGetDashboardGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetDashboardQueryResult>): GetDashboardQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashboardGetDashboardGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardGetDashboardGet$Response(params?: ApiDashboardGetDashboardGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDashboardQueryResult>> {
    return apiDashboardGetDashboardGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDashboardGetDashboardGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardGetDashboardGet(params?: ApiDashboardGetDashboardGet$Params, context?: HttpContext): Observable<GetDashboardQueryResult> {
    return this.apiDashboardGetDashboardGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetDashboardQueryResult>): GetDashboardQueryResult => r.body)
    );
  }

  /** Path part for operation `apiDashboardGetDashboardV2Post()` */
  static readonly ApiDashboardGetDashboardV2PostPath = '/api/Dashboard/GetDashboardV2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashboardGetDashboardV2Post$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDashboardGetDashboardV2Post$Plain$Response(params?: ApiDashboardGetDashboardV2Post$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDashboardV2QueryResult>> {
    return apiDashboardGetDashboardV2Post$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDashboardGetDashboardV2Post$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDashboardGetDashboardV2Post$Plain(params?: ApiDashboardGetDashboardV2Post$Plain$Params, context?: HttpContext): Observable<GetDashboardV2QueryResult> {
    return this.apiDashboardGetDashboardV2Post$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetDashboardV2QueryResult>): GetDashboardV2QueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashboardGetDashboardV2Post()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDashboardGetDashboardV2Post$Response(params?: ApiDashboardGetDashboardV2Post$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDashboardV2QueryResult>> {
    return apiDashboardGetDashboardV2Post(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDashboardGetDashboardV2Post$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDashboardGetDashboardV2Post(params?: ApiDashboardGetDashboardV2Post$Params, context?: HttpContext): Observable<GetDashboardV2QueryResult> {
    return this.apiDashboardGetDashboardV2Post$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetDashboardV2QueryResult>): GetDashboardV2QueryResult => r.body)
    );
  }

}
